import assert from '@/sui/tools/assert'
import rtti from '@/sui/tools/rtti'

import tools from '@/sui/data/sheets/convert/tools'

function serverToClient (client, server, errors, operations) {
  const stack = [{ client: client, server: server, operations: operations }]

  while (stack.length !== 0) {
    const c = stack[0]
    for (let i in c.operations) {
      const o = c.operations[i]
      assert.notNull(o.field, `o.field is null : ${i}`)

      if (o.object != null) {
        stack.push({
          client: c.client,
          server: c.server[o.field],
          operations: o.object
        })
      } else if (o.array != null) {
        const array = []
        const items = c.server[o.field]
        if (items != null) {
          for (let i in items) {
            const item = items[i]
            const target = {}
            array.push(target)
            stack.push({
              client: target,
              server: item,
              operations: o.array
            })
          }
        }
        c.client[tools.clientField(o)] = array
      } else if (o.special != null) {
        if (rtti.isString(o.special)) {
          assert.notNull(tools[o.special])
          tools[o.special].serverToClient(c.client, c.server, errors, o)
        } else {
          o.special.serverToClient(c.client, c.server, errors, o)
        }
      } else {
        c.client[tools.clientField(o)] = c.server[o.field]
      }
    }

    stack.shift()
  }
}

function clientToServer (client, server, errors, operations) {
  const stack = [{ client: client, server: server, operations: operations }]
  while (stack.length !== 0) {
    const c = stack[0]
    for (let i in c.operations) {
      const o = c.operations[i]
      assert.notNull(o.field)

      if (o.object != null) {
        const object = {}
        stack.push({
          client: c.client,
          server: object,
          operations: o.object
        })
        c.server[o.field] = object
      } else if (o.array != null) {
        const array = []
        const items = c.client[tools.clientField(o)]
        if (items != null && items.length > 0) {
          const count = items.length
          for (let i = 0; i !== count; ++i) {
            const item = items[i]
            assert(o.array.length > 0)
            const op = o.array[0]
            const field = item[tools.clientField(op)]
            if (field != null) {
              const target = {}
              array.push(target)
              stack.push({
                client: item,
                server: target,
                operations: o.array
              })
            }
          }
        }
        c.server[o.field] = array
      } else if (o.special != null) {
        if (rtti.isString(o.special)) {
          assert.notNull(tools[o.special])
          tools[o.special].clientToServer(c.client, c.server, errors, o)
        } else {
          o.special.clientToServer(c.client, c.server, errors, o)
        }
      } else {
        const value = c.client[tools.clientField(o)]
        if (value != null) {
          c.server[o.field] = value
        }
      }
    }

    stack.shift()
  }
}

export default {
  clientToServer,
  serverToClient
}
